export const formatDate = (date, hideSeconds = false) => {
  const d = new Date(date);

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  if (hideSeconds) {
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  }

  return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
};

export const formatSimpleDate = (date) => {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  return day + "/" + month + "/" + year;
};

export function formateApiDate(date) {
  let dateFrom = date.getFullYear() + "-";
  if (date.getMonth() + 1 < 10) {
    dateFrom = dateFrom + "0" + (date.getMonth() + 1) + "-";
  } else {
    dateFrom = dateFrom + (date.getMonth() + 1) + "-";
  }
  if (date.getDate() < 10) {
    dateFrom = dateFrom + "0" + date.getDate();
  } else {
    dateFrom = dateFrom + date.getDate();
  }

  return dateFrom;
}

export function formatStringDate(date) {
  if (date) {
    let dateShow = date?.getDate();
    let dateMonth = date?.getMonth() + 1;
    if (dateShow < 10) {
      dateShow = "0" + dateShow;
    }
    if (dateMonth < 10) {
      dateMonth = "0" + dateMonth;
    }
    return dateShow + "/" + dateMonth + "/" + date?.getFullYear();
  }
}

export const maskDate = (value) => {
  debugger;
  if (value.length > 10) {
    return value.slice(0, 10);
  }

  let v = value.replace(/\D/g, "").slice(0, 10);
  if (v.length >= 5) {
    return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
  } else if (v.length >= 3) {
    return `${v.slice(0, 2)}/${v.slice(2)}`;
  }

  return v;
};

const DateFunctions = {
  formatDate: formatDate,
  formatSimpleDate: formatSimpleDate,
  formateApiDate: formateApiDate,
  formatStringDate: formatStringDate,
  maskDate: maskDate,
};

export default DateFunctions;
